import { get } from 'Api';
import { currencyCode, nativeCurrencyCode } from 'Helpers/Geo/Country';

export const GET_NATIVE_RATES = 'frontend/native-rates/GET_NATIVE_RATES';
export const REMOVE_NATIVE_RATES = 'frontend/native-rates/REMOVE_NATIVE_RATES';

export function getNativeCurrencyRate() {
  return (dispatch) => {
    const code = localStorage.getItem('displayCurrency');


    if (!code) {
      return false;
    }

    if (code === currencyCode || code !== nativeCurrencyCode) {
      return dispatch({ type: REMOVE_NATIVE_RATES });
    }

    return get(dispatch, `/payment/get-conversion-rate/${code}`)
      .then(({ response, data }) => {
        if (response && data) {
          return dispatch({ type: GET_NATIVE_RATES, payload: data });
        }
        return dispatch({ type: REMOVE_NATIVE_RATES });
      });
  };
}
